<template>
  <div class="md container mx-auto p-8 bg-white rounded-lg rounded-l-none shadow-lg pb-0 md:pb-8">
    <BrokerSignUpForm :display-password="false" :aggregatorId="aggregatorId"></BrokerSignUpForm>
  </div>
</template>

<script>
import BrokerSignUpForm from '@/components/BrokerSignUpForm';
import {mapActions} from 'vuex';

export default {
  name: 'AggregatorBrokerSignUp',
  metaInfo: {
    title: 'Accredit a Broker | SocietyOne Personal Loans',
  },
  components: {BrokerSignUpForm},
  props: ['brokerId'],
  computed: {
    aggregatorId: function () {
      const tokenData = this.$auth.getTokenData();
      return `${tokenData.userId}`;
    },
  },
  created() {
    this.setId(this.brokerId);
  },
  mounted() {
    this.$ga.page('/accreditation/broker/request/');
    this.$gtm.trackView('AggregatorBrokerSignUp', '/accreditation/broker/request/');
  },
  methods: {
    ...mapActions({
      setId: 'broker/setId',
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Aggregator/AggregatorBrokerSignUp.vue